module.exports = __webpack_public_path__ + "static/media/image.046c4b04.svg";